import { useApprovalText } from '@/hooks/useApprovelText';
import { cn } from '@/utils/cn';

export const ApprovalText = ({ withPadding = true }: { withPadding?: boolean }) => {
  const { footerText } = useApprovalText();

  return (
    <div
      className={cn(
        'w-full flex items-center justify-center text-center text-muted-foreground text-xs',
        withPadding && 'pt-[18px]'
      )}
    >
      <span className="inline approval-footer-text" dangerouslySetInnerHTML={{ __html: footerText }}></span>
    </div>
  );
};
